import axios from 'axios';
import { GraphqlResponse } from './types';
import { STOREFRONT_API_KEY, STOREFRONT_API_URL } from '../../constants';

export async function graphqlApiClient<TData, TVariables = Record<string, unknown>>(
  query: string,
  variables?: TVariables
): Promise<TData> {
  const response = await axios.post<GraphqlResponse<TData>>(
    STOREFRONT_API_URL!,
    { query, variables },
    { headers: { 'X-Shopify-Storefront-Access-Token': STOREFRONT_API_KEY } }
  );

  // GraphQLエラー
  if (response.data.errors?.length) {
    throw new Error(response.data.errors[0].message);
  }

  if (!response.data.data) {
    throw new Error('GraphQL data is undefined');
  }

  return response.data.data;
}
